export const sortArtists = (allArtists: server.dto.ArtistSmall[], recentlyUsed: number[]): server.dto.ArtistSmall[] => {
  const nonRecentlyUsedArtists = allArtists.filter(a => !recentlyUsed.includes(a.artistId));
  const recentlyUsedArtists = allArtists.filter(a => recentlyUsed.includes(a.artistId));

  return [...recentlyUsedArtists, ...nonRecentlyUsedArtists];
};